import { createSelector } from 'reselect';

const selectReturnRequests = (state: any) => state.returnRequests;


export const selectReturnRequestsCurrentItem = createSelector([selectReturnRequests], (returnRequests) => returnRequests.current);

export const selectReturnRequestsListItems = createSelector([selectReturnRequests], (returnRequests) => returnRequests.list);

export const selectReturnRequestsItemById = (itemId: any) =>
    createSelector(selectReturnRequestsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectReturnRequestsQueryItems = createSelector([selectReturnRequests], (returnRequests) => returnRequests.query);

export const selectReturnRequestsCreatedItem = createSelector([selectReturnRequests], (returnRequests) => returnRequests.create);

export const selectReturnRequestsUpdatedItem = createSelector([selectReturnRequests], (returnRequests) => returnRequests.update);

export const selectReturnRequestsReadItem = createSelector([selectReturnRequests], (returnRequests) => returnRequests.read);

export const selectReturnRequestsDeletedItem = createSelector([selectReturnRequests], (returnRequests) => returnRequests.delete);

export const selectReturnRequestsSearchedItems = createSelector([selectReturnRequests], (returnRequests) => returnRequests.search);

export const selectReturnRequestsItemsCount = createSelector([selectReturnRequests], (returnRequests) => returnRequests.count);

export const selectReturnRequestsItemsFilter = createSelector([selectReturnRequests], (returnRequests) => returnRequests.filter);